import React, {useEffect, useState} from 'react';
import {Box, VStack, Text, useTheme} from '@chakra-ui/react';
import PlaceCard from '../../components/Articles/PlaceCard';
import {Place} from '../../types/article';
import {TextG16, TextG18, TextG32} from '../../components/typography';

// Mock place data for the PlaceCard
const mockPlace = {
  id: 1,
  name: 'Roast Coffee Shop',
  place_type_id: 1,
  image_url: 'https://placehold.co/400x300/e2e8f0/1a202c?text=Coffee+Shop',
  latitude: 32.7157,
  longitude: -117.1611,
  description: 'Great coffee shop with amazing atmosphere',
  partner: null,
  tags_counted: [{name: 'coffee'}, {name: 'jazz music'}] as any,
} as Partial<Place> as Place;

const IntroFeatures = () => {
  const theme = useTheme();
  const [animationPhase, setAnimationPhase] = useState(0);

  useEffect(() => {
    // Trigger the fan-out animation after component mounts
    // Phase 0: Only front card visible
    // Phase 1: Cards fan out (after 400ms)
    // Phase 2: Badge slides up (after 800ms)
    const timer1 = setTimeout(() => setAnimationPhase(1), 400);
    const timer2 = setTimeout(() => setAnimationPhase(2), 800);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <VStack
      flex={1}
      spacing={8}
      px={4}
      pt={8}
      pb={4}
      align="center"
      justify="flex-start"
      overflow="auto">
      {/* Title */}
      <Box textAlign="center" maxW="350px">
        <TextG32 fontSize="32px" fontWeight="700" mb={0} color={theme.colors.gray[900]}>
          {`Start making `}
          <TextG32 as="span" color="#C9136B">
            local plans
          </TextG32>
        </TextG32>
      </Box>

      {/* Card Stack with Fan-out Animation */}
      <Box
        w="100%"
        maxW="300px"
        position="relative"
        h="230px"
        margin="70px 0px 70px 15px !important">
        {/* Back Card - rotates more counter-clockwise */}
        <Box
          position="absolute"
          bottom={animationPhase >= 1 ? '28px' : '0px'}
          left="50%"
          transform={`translateX(calc(-50%)) rotate(${
            animationPhase >= 1 ? '-20.548deg' : '0deg'
          })`}
          transformOrigin="bottom left"
          w="100%"
          zIndex={1}
          transition="all 0.5s ease-in-out"
          pointerEvents="none">
          <PlaceCard place={mockPlace} />
        </Box>

        {/* Middle Card - rotates less counter-clockwise */}
        <Box
          position="absolute"
          bottom={animationPhase >= 1 ? '14px' : '0px'}
          left="50%"
          transform={`translateX(calc(-50%)) rotate(${animationPhase >= 1 ? '-8.64deg' : '0deg'})`}
          transformOrigin="bottom left"
          w="100%"
          zIndex={2}
          transition="all 0.5s ease-in-out"
          pointerEvents="none">
          <PlaceCard place={mockPlace} />
        </Box>

        {/* Front Card - no rotation, always visible */}
        <Box
          position="absolute"
          bottom="0px"
          left="50%"
          transform="translateX(-50%)"
          w="100%"
          zIndex={3}
          pointerEvents="none">
          <PlaceCard place={mockPlace} />
        </Box>

        {/* Bottom Badge - slides up from below */}
        <Box
          position="absolute"
          bottom={animationPhase >= 2 ? '-38px' : '-80px'}
          left="50%"
          transform="translateX(-50%)"
          px="16px"
          py="8px"
          borderRadius="full"
          boxShadow="0 4px 12px rgba(0,0,0,0.1)"
          zIndex={4}
          border="2.375px solid #E9E9E9"
          bg="#FFF"
          opacity={animationPhase >= 2 ? 1 : 0}
          transition="all 0.5s ease-in-out"
          whiteSpace="nowrap">
          <TextG16 fontWeight="400" color={'#202020'}>
            You and 6 neighbors are into this!
          </TextG16>
        </Box>
      </Box>

      {/* Description */}
      <Box textAlign="center" maxW="350px" px={4} pt={0} mt="0px !important">
        <TextG18 color="#262626" fontWeight="500" lineHeight="28px">
          Discover what's happening nearby, save what interests you, and meet neighbors who want to
          do it too.
        </TextG18>
      </Box>
    </VStack>
  );
};

export default IntroFeatures;
